<div [ngClass]="{ isFilterExpanded: isFilterExpanded }">
    <div class="account-log-query-container box-border">
        <mat-icon id="search-prefix" class="fp-icon-search search-log" fxFlex="0 1 auto"></mat-icon>
        <clare-search
            placeholder="Search by event type, user, etc."
            [initialValue]="queryString"
            (searchDataHandler)="onSearchingEvents($event)"
        ></clare-search>
        <mat-icon svgIcon="cc-filter" (click)="toggleFilter()" class="toggleFilter"></mat-icon>
        <button (click)="onDataRefresh()" mat-icon-button aria-label="click to refresh">
            <img src="assets/images/two-arrow-refresh.svg" alt="refresh icon" />
        </button>
    </div>
    <mat-expansion-panel
        [hideToggle]="true"
        [expanded]="isFilterExpanded"
        class="expanded-filter-container"
        class="expanded-filter-container"
    >
        <div>
            <div class="event-type-container">
                <form [formGroup]="filterForm">
                    <div fxLayout="row wrap" class="mt-10 event-type" fxLayoutAlign="space-between stretch">Event Types</div>
                    <div fxLayout="row wrap" class="mt-10" fxLayoutAlign="space-between stretch">
                        <div fxFlex.gt-sm="1 1 100%" fxFlex="1 1 100%">
                            <div fxLayout="row wrap" fxLayoutAlign="space-between stretch">
                                <div fxFlex="1 1 100%">
                                    <div [formGroup]="filterForm" class="log-checkbox-container">
                                        <div fxLayout="row wrap" fxLayoutAlign="space-between stretch">
                                            <div fxFlex.gt-sm="1 1 48%" fxFlex="1 1 100%">
                                                <mat-form-field appearance="outline" class="full-width">
                                                    <mat-select formControlName="type" appearance="outline">
                                                        <mat-option value="">Event Types</mat-option>
                                                        <mat-option *ngFor="let type of typeList" [value]="type">{{ type }}</mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                            <div fxFlex.gt-sm="1 1 48%" fxFlex="1 1 100%">
                                                <mat-form-field appearance="outline" class="full-width">
                                                    <mat-select formControlName="subType" appearance="outline">
                                                        <mat-option value="">Event Sub Types</mat-option>
                                                        <mat-option *ngFor="let subType of subTypeList" [value]="subType">{{
                                                            subType
                                                        }}</mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                        </div>

                                        <div fxLayout="row wrap" class="mt-10" fxLayoutAlign="space-between stretch">
                                            <div fxFlex="1 1 100%">
                                                <mat-form-field appearance="outline" class="full-width">
                                                    <mat-select formControlName="user" appearance="outline">
                                                        <mat-option value="">User</mat-option>
                                                        <mat-option *ngFor="let user of userList" [value]="user">
                                                            {{ user.userName }} ({{ user.email }})
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                        </div>

                                        <div fxLayout="row wrap" class="mt-10" fxLayoutAlign="space-between stretch">
                                            <div fxFlex.gt-sm="1 1 100%" fxFlex="1 1 100%">
                                                <div fxLayout="row wrap" fxLayoutAlign="space-between stretch">
                                                    <div fxFlex.gt-sm="1 1 48%" fxFlex="1 1 100%">
                                                        <clare-date-picker
                                                            label="Start Date"
                                                            appearance="outline"
                                                            [max]="initEndDate"
                                                            [date]="startTime"
                                                            (dateUpdated)="onStartDateSelect($event)"
                                                        >
                                                        </clare-date-picker>
                                                    </div>
                                                    <div fxFlex.gt-sm="1 1 48%" fxFlex="1 1 100%">
                                                        <clare-date-picker
                                                            label="End Date"
                                                            appearance="outline"
                                                            [max]="initEndDate"
                                                            [date]="endTime"
                                                            [shouldReturnEndOfDay]="true"
                                                            (dateUpdated)="onEndDateSelect($event)"
                                                        >
                                                        </clare-date-picker>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <div fxLayout="row-reverse wrap" fxLayoutAlign="space-between stretch">
                    <div fxFlex="1 1 100%" class="filter-action">
                        <button mat-stroked-button (click)="resetFilter()" class="reboot-btn">Clear</button>
                        &nbsp;
                        <button mat-raised-button (click)="applyFilter()" color="primary" class="reboot-btn new-primary-button">
                            Apply
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </mat-expansion-panel>
</div>
